// extracted by mini-css-extract-plugin
export default {"floatingFigure":"Guaipeca_floatingFigure__4CuLK","clearFloat":"Guaipeca_clearFloat__yNbCO"};